import * as types from '@/store/types'
export default {
    variables: state => {
        return state.variables
    },
    variablesLists: state => {
        return state.variablesLists
    },
    variableDefault: state => {
        return state.variableDefault
    },
    variablesListDefault: state => {
        return state.variablesListDefault
    },
    variablesLoaded: state => {
        return state.variablesLoaded
    },
    variablesListsLoaded: state => {
        return state.variablesListsLoaded
    },
    getVariableById: state => id => {
        return state.variables.find(model => model.id === id)
    },
    getVariablesListById: state => id => {
        return state.variablesLists.find(model => model.id === id)
    },
    unsortedVariablesListId: state => {
        return state.unsortedVariablesListId
    }
}
